import { BarColor } from '../Button'

export const getBarColor = ({ barColor }: { barColor: BarColor }) =>
  `background-color: ${barColor}`
